import http from '@/axios/http'

const fetch = ({ url = '/get_events' }) =>
  http
    .get(url)
    .then(response => response.data)

export const summary = (eventId) =>
  http
    .get(`/get_event_summary?event_id=${eventId}`)
    .then(response => response.data)

export default fetch
